import axios from 'axios';

import { useServicerStore } from '../store';
import { saveAuthData } from '../helpers/authStorage';
import getUserRole from '../helpers/getUserRole';
import { API_URL } from '../constants/main';

const AuthService = {
  async login(values, callback) {
    const response = await axios.post(`${API_URL}/auth/login`, {
      ...values,
      servicer_id: useServicerStore.getState()?.servicerId,
    });

    const { authToken } = response.data;
    saveAuthData({ accessToken: authToken });

    const me = await AuthService.getMe();
    const userRole = getUserRole(me);
    useServicerStore.setState({ userRole });
    useServicerStore.setState({ userId: me.id });

    callback();

    return response.data;
  },

  async getServicersId() {
    const domain = window.location.host.split('.').slice(-2).join('.');
    const subdomain = window.location.host.split('.')[0];

    const response = await axios.get('/servicer_lookup', {
      params: {
        domain,
        subdomain,
      },
    });

    if (!response.data) {
      return {
        id: 1,
      };
    }

    return response.data;
  },

  async checkInviteCode(code) {
    const response = await axios.get(`/auth/accept/${code}`);

    return response.data;
  },

  async acceptInviteAndSetPassword({ inviteCode, password }) {
    const response = await axios.patch(`/auth/accept/${inviteCode}`, {
      password,
    });

    return response.data;
  },

  async getMe() {
    const response = await axios.get(`${API_URL}/auth/me`);

    return response.data;
  },

  async getQuickAuthCode() {
    const response = await axios.get('/auth/quick_auth_code');

    return response.data;
  },

  async validateQuickAuthCode(code) {
    const response = await axios.get('/auth/validate_quick_auth_code', {
      params: {
        quick_auth_code: code,
      },
    });

    return response.data;
  },

  async sendResetPasswordLink(email) {
    const response = await axios.post('/auth/send_password_reset', {
      email,
    });

    return response.data;
  },

  async setNewPasswordAfterReset({ token, password }) {
    const response = await axios.post('/auth/reset_password', {
      quick_auth_code: token,
      password,
    });

    return response.data;
  },
};

export default AuthService;
